  import { jsx as _jsx, jsxs as _jsxs } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-utilities';
import { ToastContainerContextProvider } from '../../contexts/toastContainerContext';
import { CollapseDelayed } from '@fluentui/react-motion-components-preview';
/**
 * Render the final JSX of ToastContainer
 */ export const renderToastContainer_unstable = (state, contextValues)=>{
    const { onMotionFinish, visible, updateId } = state;
    assertSlots(state);
    return /*#__PURE__*/ _jsx(ToastContainerContextProvider, {
        value: contextValues.toast,
        children: /*#__PURE__*/ _jsx(CollapseDelayed, {
            appear: true,
            onMotionFinish: onMotionFinish,
            visible: visible,
            unmountOnExit: true,
            children: /*#__PURE__*/ _jsxs(state.root, {
                children: [
                    state.root.children,
                    /*#__PURE__*/ _jsx(state.timer, {}, updateId)
                ]
            })
        })
    });
};
